import {initializeSentry} from './src/lib/sentry';

initializeSentry();
